import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import actionType from '../../../Redux/Actions/ActionTypes';
import { LoadRegistrastionJournyData } from "../../../Redux/Actions/Actions";
import notify from '../../../Notifications/ToastifyActions';

function FetchAllAssetsAsinWiseService(token,data) {
    console.log(token)
    return axios.post(`${CURRENT_API_URL}/AmazonProductListing/fetchAllAssetsAsinWise`, data, {
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        // notify.NotifySuccess("Your weekly recipient updated successfully!");
        return res.data;
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while Adding Recipient. please try again later.");
        return false;
    });
}


export default FetchAllAssetsAsinWiseService;